import React, {memo, useMemo, useRef, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { Scrollbars } from "react-custom-scrollbars";

import clsx from 'clsx';

import { formatNumber, formatNumberToM, formatPrice, formatQtty } from '../helpers/utils';
import { constTabName, constMarketCode } from '../helpers/constData';
import { changeSelectShowInfo, showPopupInfo } from '../redux/actions/sharedActions';

export default memo(function PriceBoardPutThrough(props) {
    const {tabName} = props;
    const marketCode = 
        tabName === constTabName.ThoaThuan_HSX ? constMarketCode.HSX :
        tabName === constTabName.ThoaThuan_HNX ? constMarketCode.HNX :
        tabName === constTabName.ThoaThuan_UpCOM ? constMarketCode.UpCOM : ""; 
        
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const refScrollBuySide = useRef(null);
    const refScrollMatch = useRef(null);
    const refScrollSellSide = useRef(null);
    
    const counter = useSelector(state => state.gSymbol.putThroughInfo?.counter);
    const {putThroughInfos} = useSelector(state => ({
        putThroughInfos: state.gSymbol.putThroughInfo?.datas,
    }), (prev, next)=>{
        return prev.putThroughInfos?.length === next.putThroughInfos?.length;
    })

    const buySideInfos = useMemo(() => {
        return putThroughInfos && putThroughInfos.filter(e => (marketCode === "" || (marketCode !== "" && e.marketCode === marketCode)) && e.type === 'O' && e.side === 'B').sort((a, b) => b.ticks - a.ticks);
    }, [counter, marketCode]);
    
    const sellSideInfos = useMemo(() => {
        return putThroughInfos && putThroughInfos.filter(e => (marketCode === "" || (marketCode !== "" && e.marketCode === marketCode)) && e.type === 'O' && e.side === 'S').sort((a, b) => b.ticks - a.ticks);
    }, [counter, marketCode]);

    const matchedInfos = useMemo(() => {
        return putThroughInfos && putThroughInfos.filter(e => (marketCode === "" || (marketCode !== "" && e.marketCode === marketCode)) && e.type === 'M').sort((a, b) => b.ticks - a.ticks);
    }, [counter, marketCode]);

    const totalTradedInfo = useMemo(() => {
        if(matchedInfos && matchedInfos.length > 0) {
            return matchedInfos.reduce(function (prevValue, currValue) {
                return { 
                    quantity: prevValue.quantity + Number(currValue.quantity),
                    value: prevValue.value + Number(currValue.value)
                };
            }, {quantity: 0, value: 0})
        }
        else {
            return {quantity: 0, value: 0};
        }
    }, [counter, marketCode]);

    //
    const _handleScrollBuySide = ({ target }) => {
        const { scrollTop, scrollLeft } = target;
        if(refScrollBuySide.current) {
            refScrollBuySide.current.scrollTo(scrollTop);
        }
    }

    const _handleScrollMatch = ({ target }) => {
        const { scrollTop, scrollLeft } = target;
        if(refScrollMatch.current) {
            refScrollMatch.current.scrollTo(scrollTop);
        }
    }

    const _handleScrollSellSide = ({ target }) => {
        const { scrollTop, scrollLeft } = target;
        if(refScrollSellSide.current) {
            refScrollSellSide.current.scrollTo(scrollTop);
        }
    }

    const _handleRowClick = (event, code) => {
        if(code) {
            if(event.target.id.includes("pt_" + code + "_code")) {
                showPopupInfo(dispatch, "ST", code);
            }
            else {
                changeSelectShowInfo(dispatch, "ST", code);
            }
        }
    }
    useEffect(() => {
        const handleOutsideClick = (event) => {
          // Kiểm tra xem phần tử được bấm có id chứa "_code" hay không
        //   if (popupRef.current && !popupRef.current.contains(event.target) && !event.target.id.includes('_code')) {
        //     // Đóng popup
        //     setPopupOpen(false);
        //   }
        };
    
        // Thêm event listener khi component được mount
        document.addEventListener('click', handleOutsideClick);
    
        // Loại bỏ event listener khi component unmount
        return () => {
          document.removeEventListener('click', handleOutsideClick);
        };
      }, []); 

    //
    return (
        <div className='d-flex flex-column flex-1'>
            {/* <p className='text-center pd_8'>{t('tongKhoiLuong')}: {formatNumber(totalTradedInfo.quantity)} {t('cpShares')}<span style={{padding: '0 10px'}}>|</span>{t('tongGiaTri')}: {formatNumber(totalTradedInfo.value)} VND</p> */}
            {/* longdh chỉnh sửa format giống tvsi */}
            {
                marketCode === constMarketCode.HSX ? (
                    <p className='text-center pd_8'>{t('tongKhoiLuong')}: {formatNumber(totalTradedInfo.quantity)} <span style={{padding: '0 10px'}}>|</span>{t('tongGiaTri(ty)')}: {(totalTradedInfo.value / 1000000000).toFixed(2)} </p>
                ) : marketCode === constMarketCode.HNX ? (
                    <p className='text-center pd_8'>{t('tongKhoiLuong')}: {formatNumber(totalTradedInfo.quantity)} <span style={{padding: '0 10px'}}>|</span>{t('tongGiaTri(ty)')}: {(formatNumber(totalTradedInfo.value / 100000))} </p>
                ) : (
                    <p className='text-center pd_8'>{t('tongKhoiLuong')}: {formatNumber(totalTradedInfo.quantity)} <span style={{padding: '0 10px'}}>|</span>{t('tongGiaTri(ty)')}: {(totalTradedInfo.value / 100000).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </p>
                )
            }
            <div className='flex-1 price-board'>
                <div className="d-flex gap-15 flex-1 h-100">
                    <div className='d-flex flex-column flex-1'>
                        <div className="prc-row-head">
                            <div className={"prc-col bdl-white"}>{t('chaoMua')}</div>
                        </div>
                        <div className="prc-row-head">
                            {/* <div className={"prc-col"}>{t('stt')}</div> */}
                            <div className={"prc-col2 bdl-white"}>{t('maCK')}</div>
                            <div className={"prc-col2"}>{t('gia')}</div>
                            <div className={"prc-col2"}>{t('kl')}</div>
                            <div className={"prc-col2"}>{t('ctck')}</div>
                            <div className={"prc-col2"}>{t('thoiGian')}</div>
                        </div>
                        <div className='flex-1'>
                            {buySideInfos && buySideInfos.length > 0 ? (
                                <AutoSizer>
                                    {({ height, width }) => {
                                        return (
                                            <Scrollbars
                                                autoHide={true}
                                                autoHeight={true}
                                                autoHeightMax={height}
                                                onScroll={_handleScrollBuySide}
                                                style={{ width: width}}
                                                renderTrackHorizontal={props => <div {...props} className="scroll-track-horizontal"/>}
                                                renderTrackVertical={props => <div {...props} className="scroll-track-vertical"/>}
                                                renderThumbHorizontal={props => <div {...props} className="scroll-thumb-horizontal"/>}
                                                renderThumbVertical={props => <div {...props} className="scroll-thumb-vertical"/>}
                                                renderView={props => <div {...props} className="scroll-view"/>}
                                                className={"scroll-container"}
                                            > 
                                                <FixedSizeList
                                                    ref={refScrollBuySide}
                                                    height={height}
                                                    width={width}
                                                    itemCount={buySideInfos.length}
                                                    itemSize={28}
                                                    style={{ overflow: false }}
                                                >
                                                    {({ index, style }) => {
                                                        const item = buySideInfos[index];
                                                        return (
                                                            <div className={clsx('prc-row', (index % 2 === 0 ? "odd" : "even"))} style={style}
                                                            //  onClick={(event) => _handleRowClick(event, item.code)}
                                                             >
                                                                {/* <div className={clsx("prc-col text-center")}>{index+1}</div> */}
                                                                <div className={clsx('prc-col2 text-left', item.price_color)} id={"pt_"+item.code+"_code_b"}>{item.code}</div>
                                                                <div className={clsx('prc-col2 text-right', item.price_color)}>{formatPrice(item.price)}</div>
                                                                <div className={clsx("prc-col2 text-right")}>{formatNumber(item.quantity)}</div>
                                                                <div className={"prc-col2 text-center"}>{item.partyId}</div>
                                                                <div className={clsx("prc-col2 text-center")}>{item.time}</div>
                                                            </div>
                                                        )
                                                    }}
                                                </FixedSizeList>
                                            </Scrollbars>
                                        )
                                    }}
                                </AutoSizer>
                            ) : null}
                        </div>
                    </div>
                    <div className='d-flex flex-column flex-1'>
                        <div className="prc-row-head">
                            <div className={"prc-col bdl-white"}>{t('khop')}</div>
                        </div>
                        <div className="prc-row-head">
                            {/* <div className={"prc-col bdl-white"}>{t('stt')}</div> */}
                            <div className={"prc-col2 bdl-white"}>{t('maCK')}</div>
                            <div className={"prc-col2"}>{t('gia')}</div>
                            <div className={"prc-col2"}>{t('kl')}</div>
                            <div className={"prc-col2"}>{t('giaTri')} ({t('trieuTr')})</div>
                            <div className={"prc-col2"}>{t('thoiGian')}</div>
                        </div>
                        <div className='flex-1'>
                            {matchedInfos && matchedInfos.length > 0 ? (
                                <AutoSizer>
                                    {({ height, width }) => {
                                        return (
                                            <Scrollbars
                                                autoHide={true}
                                                autoHeight={true}
                                                autoHeightMax={height}
                                                onScroll={_handleScrollMatch}
                                                style={{ width: width}}
                                                renderTrackHorizontal={props => <div {...props} className="scroll-track-horizontal"/>}
                                                renderTrackVertical={props => <div {...props} className="scroll-track-vertical"/>}
                                                renderThumbHorizontal={props => <div {...props} className="scroll-thumb-horizontal"/>}
                                                renderThumbVertical={props => <div {...props} className="scroll-thumb-vertical"/>}
                                                renderView={props => <div {...props} className="scroll-view"/>}
                                                className={"scroll-container"}
                                            > 
                                                <FixedSizeList
                                                    ref={refScrollMatch}
                                                    height={height}
                                                    width={width}
                                                    itemCount={matchedInfos.length}
                                                    itemSize={28}
                                                    style={{ overflow: false }}
                                                >
                                                    {({ index, style }) => {
                                                        const item = matchedInfos[index];
                                                        return (
                                                            <div className={clsx('prc-row', (index % 2 === 0 ? "odd" : "even"))} style={style} 
                                                            // onClick={(event) => _handleRowClick(event, item.code)}
                                                            >
                                                                {/* <div className={clsx("prc-col text-center")}>{index+1}</div> */}
                                                                <div className={clsx('prc-col2 text-left has-symbol', item.price_color)} id={"pt_"+item.code+"_code_m"}>{item.code}</div>
                                                                <div className={clsx('prc-col2 text-right', item.price_color)}>{formatPrice(item.price)}</div>
                                                                <div className={clsx("prc-col2 text-right")}>{formatNumber(item.quantity)}</div>
                                                                <div className={clsx("prc-col2 text-right")}>{formatNumberToM(item.value)}</div>
                                                                <div className={clsx("prc-col2 text-center")}>{item.time}</div>
                                                            </div>
                                                        )
                                                    }}
                                                </FixedSizeList>
                                            </Scrollbars>
                                        )
                                    }}
                                </AutoSizer>
                            ) : null}
                        </div>
                    </div>
                    <div className='d-flex flex-column flex-1'>
                        <div className="prc-row-head">
                            <div className={"prc-col bdl-white"}>{t('chaoBan')}</div>
                        </div>
                        <div className="prc-row-head">
                            {/* <div className={"prc-col"}>{t('stt')}</div> */}
                            <div className={"prc-col2 bdl-white"}>{t('maCK')}</div>
                            <div className={"prc-col2"}>{t('gia')}</div>
                            <div className={"prc-col2"}>{t('kl')}</div>
                            <div className={"prc-col2"}>{t('ctck')}</div>
                            <div className={"prc-col2"}>{t('thoiGian')}</div>
                        </div>
                        <div className='flex-1'>
                            {sellSideInfos && sellSideInfos.length > 0 ? (
                                <AutoSizer>
                                    {({ height, width }) => {
                                        return (
                                            <Scrollbars
                                                autoHide={true}
                                                autoHeight={true}
                                                autoHeightMax={height}
                                                onScroll={_handleScrollSellSide}
                                                style={{ width: width}}
                                                renderTrackHorizontal={props => <div {...props} className="scroll-track-horizontal"/>}
                                                renderTrackVertical={props => <div {...props} className="scroll-track-vertical"/>}
                                                renderThumbHorizontal={props => <div {...props} className="scroll-thumb-horizontal"/>}
                                                renderThumbVertical={props => <div {...props} className="scroll-thumb-vertical"/>}
                                                renderView={props => <div {...props} className="scroll-view"/>}
                                                className={"scroll-container"}
                                            > 
                                                <FixedSizeList
                                                    ref={refScrollSellSide}
                                                    height={height}
                                                    width={width}
                                                    itemCount={sellSideInfos.length}
                                                    itemSize={28}
                                                    style={{ overflow: false }}
                                                >
                                                    {({ index, style }) => {
                                                        const item = sellSideInfos[index];
                                                        return (
                                                            <div className={clsx('prc-row', (index % 2 === 0 ? "odd" : "even"))} style={style}
                                                            //  onClick={(event) => _handleRowClick(event, item.code)}
                                                             >
                                                                {/* <div className={clsx("prc-col text-center")}>{index+1}</div> */}
                                                                <div className={clsx('prc-col2 text-left', item.price_color)} id={"pt_"+item.code+"_code_s"}>{item.code}</div>
                                                                <div className={clsx('prc-col2 text-right', item.price_color)}>{formatPrice(item.price)}</div>
                                                                <div className={clsx("prc-col2 text-right")}>{formatNumber(item.quantity)}</div>
                                                                <div className={"prc-col2 text-center"}>{item.partyId}</div>
                                                                <div className={clsx("prc-col2 text-center")}>{item.time}</div>
                                                            </div>
                                                        )
                                                    }}
                                                </FixedSizeList>
                                            </Scrollbars>
                                        )
                                    }}
                                </AutoSizer>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}, (prevProps, nextProps) => {
    if (prevProps.tabName === nextProps.tabName) {
        return true;
    }
    return false;
})
